<template>
  <div class="rt-card"><slot /></div>
</template>

<script>
export default {
  name: 'RtCard'
};
</script>



// WEBPACK FOOTER //
// rtCard.vue?0c83ef1e